<div style="margin: 11px;" id="strength" #strength>
  <small>{{ barLabel }}</small>
  <ul id="strengthBar">
    @for (bar of bars; track bar) {
      <li class="point" [style.background-color]="bar"></li>
    }
  </ul>
</div>
